export default __webpack_public_path__ + "static/01-ad453d4bc1097cd928bb8d57ef6242c9.jpg";